import React from 'react'
import { ClipboardList, Warehouse, UserCheck, FileCheck2, History } from 'lucide-react'
import { tr } from 'i18n'
import { useRequestCounts } from 'components/Erp/RequestCountsContext'
import RequestCount from 'components/Erp/RequestCount/RequestCount.tsx'
import styles from 'pages/AdminPanelPage/Management.module.scss'
import './RequestsTabs.scss'

const icons = { mine: ClipboardList, bases: Warehouse, registrations: UserCheck, documents: FileCheck2, history: History }

export default function RequestsTabs({ tabs, tab, onChange }) {
  const counts = useRequestCounts()
  return <div className={`${styles.tabs} requests-tabs`} aria-label={tr('Заявки')}>
    {tabs.map(([key, label]) => {
      const Icon = icons[key]
      const hasCount = key !== 'history'
      const description = hasCount ? `${tr('На рассмотрении')}: ${counts[key] ?? '—'}` : ''
      return <button type="button" key={key} className={`${styles.tab} ${tab === key ? styles.tabActive : ''}`}
        onClick={() => onChange(key)} aria-pressed={tab === key} aria-label={tr(label)}
        title={description || undefined}>
        <Icon size={16} aria-hidden="true" />{tr(label)}
        {hasCount && <RequestCount count={counts[key]} />}
      </button>
    })}
  </div>
}
